import { render, staticRenderFns } from "./TestScoresTab.vue?vue&type=template&id=dd11aba8&scoped=true"
import script from "./TestScoresTab.vue?vue&type=script&lang=js"
export * from "./TestScoresTab.vue?vue&type=script&lang=js"
import style0 from "./TestScoresTab.vue?vue&type=style&index=0&id=dd11aba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd11aba8",
  null
  
)

export default component.exports